import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
// MODIFIED: Updated paths to common components
import { Button } from "../../../../../common/APICommon";
import EmployeePickerField from "../../../../../common/selectComponents/EmployeePicker";

export function ApproverListTab({
  isViewOnly,
  approverHierarchyCount,
  hierarchyLevels,
  setHierarchyLevels,
  errorState,
  selectedEmployeeId,
  showGeneralMessage,
}) {
  const getApproverFilter = (levelIndex, slotIndex) => {
    return (employee) => {
      const employeeId = parseInt(employee.id);
      if (selectedEmployeeId && employeeId === parseInt(selectedEmployeeId)) return false;

      const allSelected = [];
      hierarchyLevels.forEach((level, lIdx) => {
        level.forEach((slot, sIdx) => {
          if (lIdx === levelIndex && sIdx === slotIndex) return;
          if (slot.approverId) allSelected.push(parseInt(slot.approverId));
        });
      });
      return !allSelected.includes(employeeId);
    };
  };

  const addApproverSlot = (levelIndex) => {
    setHierarchyLevels((prev) => {
      const updated = [...prev];
      updated[levelIndex] = [...updated[levelIndex], { approverId: "", fullName: "" }];
      return updated;
    });
  };

  const removeApproverSlot = (levelIndex, slotIndex) => {
    setHierarchyLevels((prev) => {
      const updated = [...prev];
      updated[levelIndex] = updated[levelIndex].filter((_, i) => i !== slotIndex);
      return updated;
    });
  };

  const handleSelectApprover = (levelIndex, slotIndex, employee) => {
    setHierarchyLevels((prev) => {
      const updated = [...prev];
      updated[levelIndex] = updated[levelIndex].map((slot, i) =>
        i === slotIndex ? { approverId: employee.id, fullName: employee.fullName } : slot
      );
      return updated;
    });
  };

  const handleClearApprover = (levelIndex, slotIndex) => {
    setHierarchyLevels((prev) => {
      const updated = [...prev];
      updated[levelIndex] = updated[levelIndex].map((slot, i) =>
        i === slotIndex ? { approverId: "", fullName: "" } : slot
      );
      return updated;
    });
  };

  return (
    <div className="space-y-4">
      {Array.from({ length: approverHierarchyCount }, (_, levelIndex) => {
        const levelNumber = levelIndex + 1;
        const slots = hierarchyLevels[levelIndex] ?? [];

        return (
          <div key={levelIndex} className="border border-gray-300 rounded-lg bg-white overflow-hidden">
            <div className="flex items-center justify-between px-4 py-2 bg-gray-100 border-b">
              <h3 className="font-medium text-gray-700 text-sm">
                Hierarchy Level {levelNumber}
              </h3>
              {!isViewOnly && (
                <Button
                  icon={<AddIcon fontSize="small" />}
                  className="text-xs text-blue-500 hover:text-blue-600 border border-blue-300 hover:border-blue-500 bg-blue-50 hover:bg-blue-100 cursor-pointer"
                  onClick={() => addApproverSlot(levelIndex)}
                  name="Add"
                />
              )}
            </div>
            <div className="p-3 space-y-3">
              {slots.map((slot, slotIndex) => (
                <div key={slotIndex} className="flex items-center space-x-2">
                  <div className="flex-1">
                    <EmployeePickerField
                      employeePersonalInformationId={slot.approverId}
                      displayValue={slot.fullName || ""}
                      onSelect={(e) => handleSelectApprover(levelIndex, slotIndex, e)}
                      onClear={() => handleClearApprover(levelIndex, slotIndex)}
                      disabled={isViewOnly}
                      filterFunction={getApproverFilter(levelIndex, slotIndex)}
                      compact={true}
                    />
                  </div>
                  {slots.length > 1 && !isViewOnly && (
                    <button onClick={() => removeApproverSlot(levelIndex, slotIndex)} className="text-red-400 border-none bg-transparent cursor-pointer">
                      <DeleteIcon fontSize="small" />
                    </button>
                  )}


                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}